// AUTO-GENERATED by scripts/extract-prototype-wrappers.mjs — do not edit.
import w0 from './display-aedicula.wrapper.json';
import w1 from './display-antiquarium.wrapper.json';
import w2 from './display-archway.wrapper.json';
import w3 from './display-armillary.wrapper.json';
import w4 from './display-atelier.wrapper.json';
import w5 from './display-atrium.wrapper.json';
import w6 from './display-aureole.wrapper.json';
import w7 from './display-base.wrapper.json';
import w8 from './display-bkg.wrapper.json';
import w9 from './display-bookends.wrapper.json';
import w10 from './display-booth.wrapper.json';
import w11 from './display-cabinet.wrapper.json';
import w12 from './display-carousel.wrapper.json';
import w13 from './display-cartouche.wrapper.json';
import w14 from './display-cascade.wrapper.json';
import w15 from './display-cluster.wrapper.json';
import w16 from './display-credenza.wrapper.json';
import w17 from './display-dais.wrapper.json';
import w18 from './display-driftfield.wrapper.json';
import w19 from './display-eclipse.wrapper.json';
import w20 from './display-enfilade.wrapper.json';
import w21 from './display-fan.wrapper.json';
import w22 from './display-fins.wrapper.json';
import w23 from './display-gallery.wrapper.json';
import w24 from './display-halo.wrapper.json';
import w25 from './display-helix.wrapper.json';
import w26 from './display-kaleidoscope.wrapper.json';
import w27 from './display-kiosk.wrapper.json';
import w28 from './display-laurel.wrapper.json';
import w29 from './display-lineup.wrapper.json';
import w30 from './display-maelstrom.wrapper.json';
import w31 from './display-mantel.wrapper.json';
import w32 from './display-orbit.wrapper.json';
import w33 from './display-orrery.wrapper.json';
import w34 from './display-pavilion.wrapper.json';
import w35 from './display-peristyle.wrapper.json';
import w36 from './display-pinwheel.wrapper.json';
import w37 from './display-portico.wrapper.json';
import w38 from './display-prism.wrapper.json';
import w39 from './display-promenade.wrapper.json';
import w40 from './display-proscenium.wrapper.json';
import w41 from './display-pylons.wrapper.json';
import w42 from './display-reredos.wrapper.json';
import w43 from './display-ribbon.wrapper.json';
import w44 from './display-ring.wrapper.json';
import w45 from './display-risers.wrapper.json';
import w46 from './display-rostrum.wrapper.json';
import w47 from './display-rotunda.wrapper.json';
import w48 from './display-shelf.wrapper.json';
import w49 from './display-stage.wrapper.json';
import w50 from './display-studio.wrapper.json';
import w51 from './display-sundial.wrapper.json';
import w52 from './display-tableau.wrapper.json';
import w53 from './display-tabletop.wrapper.json';
import w54 from './display-terrace.wrapper.json';
import w55 from './display-tiered.wrapper.json';
import w56 from './display-triptych.wrapper.json';
import w57 from './display-visavis.wrapper.json';
import w58 from './display-vitrine.wrapper.json';
import w59 from './exhibition.wrapper.json';

export const WRAPPER_ARTIFACTS: Record<string, unknown> = {
    'display-aedicula': w0,
    'display-antiquarium': w1,
    'display-archway': w2,
    'display-armillary': w3,
    'display-atelier': w4,
    'display-atrium': w5,
    'display-aureole': w6,
    'display-base': w7,
    'display-bkg': w8,
    'display-bookends': w9,
    'display-booth': w10,
    'display-cabinet': w11,
    'display-carousel': w12,
    'display-cartouche': w13,
    'display-cascade': w14,
    'display-cluster': w15,
    'display-credenza': w16,
    'display-dais': w17,
    'display-driftfield': w18,
    'display-eclipse': w19,
    'display-enfilade': w20,
    'display-fan': w21,
    'display-fins': w22,
    'display-gallery': w23,
    'display-halo': w24,
    'display-helix': w25,
    'display-kaleidoscope': w26,
    'display-kiosk': w27,
    'display-laurel': w28,
    'display-lineup': w29,
    'display-maelstrom': w30,
    'display-mantel': w31,
    'display-orbit': w32,
    'display-orrery': w33,
    'display-pavilion': w34,
    'display-peristyle': w35,
    'display-pinwheel': w36,
    'display-portico': w37,
    'display-prism': w38,
    'display-promenade': w39,
    'display-proscenium': w40,
    'display-pylons': w41,
    'display-reredos': w42,
    'display-ribbon': w43,
    'display-ring': w44,
    'display-risers': w45,
    'display-rostrum': w46,
    'display-rotunda': w47,
    'display-shelf': w48,
    'display-stage': w49,
    'display-studio': w50,
    'display-sundial': w51,
    'display-tableau': w52,
    'display-tabletop': w53,
    'display-terrace': w54,
    'display-tiered': w55,
    'display-triptych': w56,
    'display-visavis': w57,
    'display-vitrine': w58,
    'exhibition': w59,
};
